import PropTypes from 'prop-types';
import React, { Component } from 'react';

import AsyncPropsLoader from '../../AsyncPropsLoader';
import CodeSplitComponentInner from './CodeSplitComponentInner';

const errorMessage = 'Looks like something is up with your network connection';
export default class CodeSplitComponent extends Component {
  static propTypes = {
    resolveAsyncProps: PropTypes.func.isRequired,
    syncProps: PropTypes.object,
  };

  render() {
    return (
      <AsyncPropsLoader
        component={CodeSplitComponentInner}
        errorMessage={errorMessage}
        syncProps={this.props.syncProps}
        resolveAsyncProps={this.props.resolveAsyncProps}
      />
    );
  }
}
